import React, { useEffect , useState} from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import {User} from "firebase/auth";
import { AuthProvider } from './contexts/authContext';
import AuthPage from './pages/auth';
import NotFoundPage from './pages/NotFoundPage';
import AlbumPage from './album/album';
import { addUser, getUser } from './firestore/db';
import { HanimcilarUser } from './firestore/firestore-types';
import { Timestamp } from 'firebase/firestore';
import AlbumsHub from './pages/AlbumsHub';
import { DEFAULT_AVATAR_URL } from './utils/image';

export interface AppProps {
  user : User | null;
}

function App(props: AppProps) {
  useEffect(() => {
    console.log("app mounted");
  }, [])
  const [userLoaded, setUserLoaded] = useState(false);
  var user = props.user;
  //if user doesn't exist in firestore, create it.
  useEffect(() => {
    if (user?.uid !== undefined && user?.uid !== null) {
      console.log("user is not null: ", user?.uid);
      getUser(user?.uid!).then((doc) => {
        if (doc !== null) {
          console.log("user exists in firestore");
          setUserLoaded(true);
        } else {
          console.log("user doesn't exist in firestore");
          var userObj: HanimcilarUser = {
            name: user?.displayName!,
            email: user?.email!,
            uid: user?.uid!,
            photoUrl: user?.photoURL || DEFAULT_AVATAR_URL,
            paymentInfo: [],
            address: "",
            created: Timestamp.now(),
            albums: [],
            collaboratorAlbums: [],
          }
          addUser(userObj as HanimcilarUser).then((r) => {
            if (r === "success") {
              console.log("user added to firestore");
              setUserLoaded(true);
            } else {
              console.error("error adding user to firestore: ", r);
            }
          })
        
      }
      }).catch((err) => {
        console.error("error getting user from firestore: ", err);
      })
    } else {
      console.log("user is null");
      setUserLoaded(true);
    }
  } , [user])
  
  const path = window.location.pathname;
  const albumOwner = decodeURIComponent(path.split('/')[1] || "");
  const albumIdDecoded = decodeURIComponent(path.split('/')[2] || "");

  const universalFooter = (
    <footer className="site-footer">
      <p>Hanimcilar &copy; 2023-{new Date().getFullYear()}. All rights reserved. Made with ♡ by <a href="https://cagancalidag.com" target="_blank" rel="noopener noreferrer">Cagan Efe Calidag</a>.</p>
    </footer>
  );

  if (!userLoaded) {
    return (
      <>
        <h1>LOADING</h1>
      </>
    );
  }

  return (
    <>
      <AuthProvider>
        <Routes>
          <Route path="/auth" element={<AuthPage user={props.user}/>} />
          <Route path="/" element={<AlbumsHub user={props.user}/>} />
          <Route path="/:albumOwner/:albumId" element={<AlbumPage user={props.user} albumOwner={albumOwner} albumId={albumIdDecoded}/>} />
          <Route path="/*" element={<NotFoundPage/>} />
        </Routes>
        {universalFooter}
      </AuthProvider>
    </>
  );
}

export default App;
